export default __webpack_public_path__ + "media/sub_banner_mobile.55e894cb.png";